import React from 'react';
import { node } from 'prop-types';
import { Box } from '@mui/material';

const Actions = ({ children }) => (
  <Box
    sx={{
      marginTop: '12px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '12px',
    }}
  >
    {children}
  </Box>
);
Actions.propTypes = {
  children: node.isRequired,
};

export default Actions;
